import { Users } from 'lucide-react'
import { useState } from 'react'
import { plural } from '../lib/format'
import { useArena } from '../store/arena'
import { OnlineList } from './arena/OnlineList'
import { BottomSheet } from './BottomSheet'

/** "3 here" in the header; opens the list of who is around (and, per game, a challenge button). */
export function OnlinePill() {
  const online = useArena((s) => s.online)
  const [open, setOpen] = useState(false)
  if (online === null) return null
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2.5 py-1 text-xs font-black tabular-nums text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-200"
        aria-label={`${plural(online, 'player')} here now`}
      >
        <span className="size-1.5 rounded-full bg-emerald-500" aria-hidden />
        <Users className="size-3.5 sm:hidden" aria-hidden />
        <span className="hidden sm:inline">{online} here</span>
        <span className="sm:hidden">{online}</span>
      </button>
      <BottomSheet open={open} onClose={() => setOpen(false)} title="Here now">
        {open && <OnlineList />}
      </BottomSheet>
    </>
  )
}
